require("./bootstrap");

import "lazysizes";

var AOS = require("aos");
AOS.init({
    disable: window.innerWidth < 1024
});

// POLYFILL
if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = function(callback, thisArg) {
        thisArg = thisArg || window;
        for (var i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}
if (!Object.entries) {
    Object.entries = function(obj) {
        var ownProps = Object.keys(obj),
            i = ownProps.length,
            resArray = new Array(i); // preallocate the Array

        while (i--) resArray[i] = [ownProps[i], obj[ownProps[i]]];

        return resArray;
    };
}

$(document).ready(function() {
    /* INCLUDE SVG */
    $('img[data-src$=".svg"]').each(function() {
        var $img = jQuery(this);
        var imgURL = $img.attr("data-src");
        var attributes = $img.prop("attributes");

        $.get(
            imgURL,
            function(data) {
                // Get the SVG tag, ignore the rest
                var $svg = jQuery(data).find("svg");

                // Remove any invalid XML tags
                $svg = $svg.removeAttr("xmlns:a");

                // Loop through IMG attributes and apply on SVG
                $.each(attributes, function() {
                    $svg.attr(this.name, this.value);
                });

                // Replace IMG with SVG
                $img.replaceWith($svg);
            },
            "xml"
        );
    });

    /* RESIZE EVENT */
    window.reportWindowSize = function() {};

    reportWindowSize();

    window.addEventListener("resize", function() {
        reportWindowSize();
    });

    /*DOWNLOAD RULES*/
    // if(getCookie('download') == 'true') {
    //     document.querySelector('#v-pills-brochure-tab').dataset.toggle = '';
    // }

    $("#logementCarousel").carousel();
    $("#logementCarousel").on("slide.bs.carousel", function(event) {
        document
            .querySelectorAll(".carousel-indicators li")
            .forEach(function(item, index) {
                item.classList.remove("active");

                if (event.to == index) {
                    item.classList.add("active");
                }
            });
    });
});

/* ANIMATE FUNCTION */
window.animateCSS = function animateCSS(element, animationName, callback) {
    var node = document.querySelector(element);
    node.classList.add("animated", animationName);

    function handleAnimationEnd() {
        node.classList.remove("animated", animationName);
        node.removeEventListener("animationend", handleAnimationEnd);

        if (typeof callback === "function") callback();
    }

    node.addEventListener("animationend", handleAnimationEnd);
};

// SCROLLto
function scrollTo(target) {
    var speed = 750;
    var windowWidth = $(window).width();

    if (windowWidth > 995) {
        $("html, body").animate(
            { scrollTop: $(target).offset().top - 150 },
            speed
        );
    } else {
        $("html, body").animate(
            { scrollTop: $(target).offset().top - 100 },
            speed
        );
    }

    return false;
}

$(".js-scrollTo").on("click", function(e) {
    e.preventDefault();

    var page = $(this).attr("href");
    var target = page.substr(page.indexOf("#"));

    if (document.querySelector(target) != null) {
        scrollTo(target);
    } else {
        window.location = page + "?scroll=1";
    }
});

// ON LOAD, SCROLL TO ANCHOR IF SCOLL=1
window.addEventListener("load", function(e) {
    if (window.location.href.includes("?scroll=1")) {
        scrollTo(
            window.location.hash.substr(0, window.location.hash.indexOf("?"))
        );
    }
});

// TOGGLE BACKDROP
window.toggleBackdrop = function(status) {
    var body = document.querySelector("body");

    if (status) {
        body.classList.add("backdroptarteaucitron");
    } else {
        body.classList.remove("backdroptarteaucitron");
    }
};

// FIND COOKIE BY NAME
function getCookie(c_name) {
    var c_value = document.cookie,
        c_start = c_value.indexOf(" " + c_name + "=");
    if (c_start == -1) c_start = c_value.indexOf(c_name + "=");
    if (c_start == -1) {
        c_value = null;
    } else {
        c_start = c_value.indexOf("=", c_start) + 1;
        var c_end = c_value.indexOf(";", c_start);
        if (c_end == -1) {
            c_end = c_value.length;
        }
        c_value = unescape(c_value.substring(c_start, c_end));
    }
    return c_value;
}

// NAV
$(document).ready(function() {
    document
        .querySelectorAll(".animation-click")
        .forEach(function(item, index) {
            /* Play a looping animation on load */
            item.dataset.lottieId = index;

            var anime = lottie.loadAnimation({
                container: document.querySelector(
                    '.animation-click[data-lottie-id="' + index + '"]'
                ), // the dom element that will contain the animation
                renderer: "svg",
                loop: true, // Set loop to true for infinite repetition
                autoplay: true, // Autoplay set to true
                name: "AnimationId" + index,
                path: "/img/" + item.dataset.animation + ".json" // the path to the animation json
            });

            var back = 1;
            anime.setDirection(back);

            // Optional: Play specific segments when animation loads
            // anime.playSegments([0, 60], true);

            // Add event listener for hover
            item.addEventListener("mouseenter", function() {
                anime.stop(); // Stop the animation on hover
            });

            // Add event listener for mouse leave (optional, to resume animation when not hovering)
            item.addEventListener("mouseleave", function() {
                anime.play(); // Resume the animation when not hovering
            });
        });

    //NavBarMobile
    window.toggleMenu = function(landingMode) {
        let navBarMobile = document.querySelector("header");

        // LANDING MODE
        if (landingMode == true) {
            navBarMobile = document.getElementById("sub-nav-programm");
        }

        navBarMobile.classList.toggle("menu-open");
        document.querySelector("body").classList.toggle("backdrop");
    };

    if (window.innerWidth >= 320) {
        (function() {
            const navBarMobile = document.querySelector("header");
            let icons = document.querySelectorAll(".icon-container ");

            icons.forEach(function(item) {
                item.addEventListener("click", function(e) {
                    window.toggleMenu(item.dataset.landing);
                });
            });
            setTimeout(function() {}, 500);
        })();
    }
});

// BG nav scroll
$(window).scroll(function() {
    var posScroll = $(document).scrollTop();
    if (posScroll >= 60) {
        $("header").addClass("scrollnav");
    } else {
        $("header").removeClass("scrollnav");
    }
});

/*
document.querySelector("meta[name=viewport]").setAttribute('content', 'width=device-width, initial-scale='+(1/window.devicePixelRatio));*/
